import { render, staticRenderFns } from "./InvoiceCreateUpdate.vue?vue&type=template&id=028a07be&scoped=true&"
import script from "./InvoiceCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCreateUpdate.vue?vue&type=style&index=0&id=028a07be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a07be",
  null
  
)

export default component.exports